import React, {useState} from "react";
import {submitFile} from "../services/firebase";
import Paper from "@material-ui/core/Paper";
import Title from "./Title";
import Typography from "@material-ui/core/Typography";
import {InlineTex} from "react-tex";
import Divider from "@material-ui/core/Divider";
import FormGroup from "@material-ui/core/FormGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import InputBase from "@material-ui/core/InputBase";
import IconButton from "@material-ui/core/IconButton";
import DirectionsIcon from "@material-ui/icons/Directions";
import {RelevantLinks} from "./Topic";
import {makeStyles} from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
    paper: {
        padding: theme.spacing(2),
        display: "flex",
        overflow: "auto",
        flexDirection: "column",
    },
    loader: {
        margin: theme.spacing(1),
    },
    input: {
        marginLeft: theme.spacing(1),
        flex: 1,
    },
    iconButton: {
        padding: 10,
    },
    root: {
        padding: "2px 4px",
        marginTop: theme.spacing(1),
        display: "flex",
        alignItems: "center",
        width: "100%",
        backgroundColor: "#f5f5f5",
    },
}));

export default function TopicHeader({ name, topic, description, links, rows, onSubmit }) {
    let initialChecked = {};
    const classes = useStyles();
    rows.forEach((row) => {
        initialChecked[row.name] = false;
    })
    const [checked, setChecked] = useState(initialChecked);
    const handleCheck = (event) => {
        setChecked({...checked, [event.target.name]: event.target.checked })
    }
    const [value, setValue] = useState("");
    const handleChange = (event) => {
        setValue(event.target.value);
    };
    const handleSubmit = (event) => {
        event.preventDefault();
        let problems = [];
        for (let k in checked) {
            if (checked[k]) {
                problems.push(k);
            }
        }
        if (window.confirm("Are you sure you would like to submit the following problems: " + problems.join(", ")+ "?")) {
            submitFile(name, problems, value);
        }
        let newChecked = {};
        rows.forEach((row) => {
            newChecked[row.name] = false;
        })
        setChecked(newChecked);
        setValue("");
        onSubmit(topic, problems)
    };
    return <Paper
        className={classes.paper}
        style={{ textAlign: "left" }}
    >
        <Title>{topic}</Title>
        <Typography component="div" variant="body1">
            <InlineTex texSeperator="$" texContent={description}/>
        </Typography>
        <Divider style={{margin: "10px 0px"}}/>
        <RelevantLinks links={links} />
        <Divider style={{margin: "10px 0px"}}/>
        <FormGroup row>
            {rows.map((row, index) => (
                <FormControlLabel
                    key={index}
                    control={
                        <Checkbox
                            disabled={row.solved}
                            color={"primary"}
                            checked={checked[row.name]}
                            onChange={handleCheck}
                            name={row.name}
                        />
                    }
                    label={row.name}
                />
            ))
            }

        </FormGroup>
        <Paper
            component="form"
            onSubmit={(event) => handleSubmit(event)}
            className={classes.root}
        >
            <InputBase
                className={classes.input}
                placeholder="Enter a shareable link to a PDF of your solutions"
                inputProps={{ "aria-label": "flag" }}
                onChange={handleChange}
                value={value}
            />
            <IconButton
                color="primary"
                type="submit"
                className={classes.iconButton}
                aria-label="directions"
            >
                <DirectionsIcon />
            </IconButton>
        </Paper>
    </Paper>
}